import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first, groupBy } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';
import { DocusignEvents, FileType, FileStatus, RFQStatus, RFQStatusLabel, FileTypeLabel, UserType, NDAStatus, NDAStatusLabel } from 'src/app/shared/constants/constants';
import { downloadUserManual, downloadFiles } from 'src/app/shared/utils';
import { DocusignService } from 'src/app/services/docusign-service/docusign.service';
@Component({
  selector: 'app-nda-upload',
  templateUrl: './nda-upload.component.html',
  styleUrls: ['./nda-upload.component.scss'],
})
export class NdaUploadComponent {
  @Output() childClick = new EventEmitter<string>();
  @Output() updateNda = new EventEmitter<void>();
  // @Input() ndaStatus: any;
  ndaStatus: any = NDAStatus;
  NDAStatusLabel: any = NDAStatusLabel;
  @Input() customerInfo: any;
  @Input() user: any;
  baseUrl = environment.BASE_URL;
  resetFileUpload = false;
  uploadedDocumentInfo!: any;
  selectedOption: string = 'unibuildNda';
  isNdaTemplate: boolean = true;
  userid: any;
  companyId = localStorage.getItem('companyId') || '';

  documentInfo: any = {
    userType: UserType.Customer,
    documentUseFor: FileTypeLabel.NDA,
    baseUrl: this.baseUrl,
  };
  fileUploadConfig: any;
  isCollapsed: boolean[] = [];
  isCollapsedRtrn: boolean[] = [];
  isContinueNDA: boolean = false;
  ndaData: any;
  customerId: any;
  fileStatus: any = FileStatus;
  isDocusignFlowStarted = false;
  constructor(
    private commonService: CommonService,
    private toastr: ToastrService,
    private docusignService: DocusignService,
    private location: Location,
  ) {
    this.userid = localStorage.getItem('customeruserId') || '';
    this.companyId = localStorage.getItem('companyId') || '';
  }

  ngOnChanges(data: any) {
    if (data?.customerInfo?.currentValue?.customerId) {
      this.customerId = data?.customerInfo?.currentValue?.customerId;
    }
    this.fileUploadConfig = {
      uploadLabel: 'Upload File',
      buttonName: 'Choose File',
      dragDropText: 'Drag & Drop File or',
      maxFileText: '(Max file size: 100MB)',
      isMultiple: false,
      fileSizeLimit: 10485760, // 10 mb in bytes
      fileLocation: `customer/${this.customerId}/nda`,
      fileFormats: '.pdf', // supported file formats for file picker
    };
    this.getNDAItems(this.customerId);
  }

  closeNda() {
    this.childClick.emit();
  }
  updateStatusNda() {
    this.updateNda.emit();
  }
  fileUploadEvent(fileUploadEvent: any): void {
    this.uploadedDocumentInfo = fileUploadEvent;
  }

  getNDAItems(customerId: number) {
    const apiURL = `${this.baseUrl}customer/nda/${customerId}?forCustomer=true`;
    this.commonService.getData(apiURL).subscribe({
      next: (res: any) => {
        this.ndaData = res?.response;
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.status.error.message);
      },
    });
  }

  requestDocumentToSign() {
    this.isDocusignFlowStarted = true;
    const redirectBaseUrl = this.docusignService.getRedirectBaseUrl(this.baseUrl);
    const reqBody: any = {
      signerName: this.user.name,
      signerEmail: this.user.email,
      userId: this.userid,
      userType: UserType.Customer,
      redirectUrl: `${redirectBaseUrl}/profile`,
    };
    this.docusignService.requestDocumentToSign(this.baseUrl, reqBody).subscribe((res) => {
      window.location.href = res.response.url; //docusign url
    });
  }

  downloadNdaTemplate() {
    let fileName = 'Customer-NDA';
    // let fileName = 'Supplier-NDA';

    downloadUserManual(this.baseUrl, this.commonService, this.toastr, fileName);
  }

  downloadNda(ndaItem: any) {
    const envelopeId = ndaItem.envelopeId;

    if (envelopeId) {
      this.docusignService
        .requestDocumentToView(this.baseUrl, envelopeId)
        .subscribe((blob: Blob) => {
          //opening pdf in new tab
          const url = window.URL.createObjectURL(blob);
          window.open(url, '_blank');
        });

      return;
    }

    // this.downloadFiles(ndaItem.attachment.fileId, ndaItem?.attachment?.fileName);
    downloadFiles(
      this.baseUrl,
      this.commonService,
      this.toastr,
      ndaItem.attachment.fileId,
      ndaItem?.attachment?.fileName,
    );
  }

  // downloadNda(fileId: number, fileName: string) {
  //   downloadFiles(this.baseUrl, this.commonService, this.toastr, fileId, fileName);
  // }

  isStatausReview(): boolean {
    if (this.ndaStatus === NDAStatus.IN_REVIEW || this.ndaStatus === NDAStatus.APPROVED) {
      return false;
    } else {
      return true;
    }
  }

  isDisabledAccept() {
    if (!this.uploadedDocumentInfo?.attachment) {
      return true;
    } else {
      return false;
    }
  }

  toggleCollapse(index: number): void {
    this.isCollapsed[index] = !this.isCollapsed[index];
  }
  toggleCollapseRtrn(index: number): void {
    this.isCollapsedRtrn[index] = !this.isCollapsedRtrn[index];
  }

  getNDALabel(ndaLabel: string) {
    let label;
    if (ndaLabel == 'IN_REVIEW') {
      label = 'In Review';
    } else if (ndaLabel == 'APPROVED') {
      label = 'Accepted';
    } else {
      label = this.NDAStatusLabel[ndaLabel];
    }
    return label;
  }
}
